<template>
  <div style="height:580px; overflow-y:auto;" class="mt-5">
    <b-row>
      <b-col lg="8" class="table-col">
        <div>
          <b-spinner
            v-if="isLoading"
            type="grow"
            class="text-center"
            style="margin-top: 10%; position:absolute;"
            variant="primary"
          ></b-spinner>

          <b-navbar toggleable="lg" type="dark" variant="light">
            <b-navbar-brand href="#" class="text-dark">
              <strong>Work flow types</strong>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                <b-nav-form>
                  <b-button
                    variant="outline-info"
                    size="sm"
                    style="margin-right:30px;"
                    @click="reloadTable"
                  >
                    <font-awesome-icon icon="sync" />
                  </b-button>
                  <b-form-group
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="sm"
                    label-for="filterInput"
                  >
                    <b-input-group size="sm">
                      <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-nav-form>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
          <b-table
            ref="table"
            id="my-table"
            :fields="fields"
            :busy.sync="isLoading"
            :items="myProvider"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
          >
            <template v-slot:cell(actions)="data">
              <button
                v-if="editUrl"
                class="btn btn-secondary mr-1 btn-sm"
                @click="itemAction('edit-item', rowData, rowIndex, editUrl)"
              >Edit</button>
            </template>
          </b-table>
          <p class="mt-3">Current Page: {{ perPage }} rows</p>
          <b-row>
            <b-col cols="2">
              <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
            </b-col>
            <b-col>
              <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                first-text="First"
                prev-text="Prev"
                next-text="Next"
                last-text="Last"
                aria-controls="my-table"
              ></b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col lg="4">
        <div>
          <b-form @submit.stop.prevent="onSubmit">
            <b-card header-tag="header" footer-tag="footer">
              <template v-slot:header>
                <h6 class="mb-0">Create New Work flow Type</h6>
              </template>
              <b-card-body class="p-0">
                <b-form-group label="Title">
                  <b-form-input
                    type="text"
                    class="form-control required"
                    placeholder="Third Party Due diligence"
                    v-model="form.onboarding_workflow"
                    :state="$v.form.onboarding_workflow.$dirty ? !$v.form.onboarding_workflow.$error : null"
                    aria-describedby
                  ></b-form-input>
                  <b-form-invalid-feedback>This is a required field and must be at least 5 characters.</b-form-invalid-feedback>
                </b-form-group>
              </b-card-body>
              <template v-slot:footer>
                <b-button type="submit" :disabled="$v.form.$invalid" variant="primary">Create</b-button>
              </template>
            </b-card>
          </b-form>
        </div>
      </b-col>
    </b-row>
    <b-modal
      ok-only
      ok-title="Close"
      no-close-on-backdrop
      hide-footer
      size="sm"
      v-model="showModal"
      scrollable
    >
      <template v-slot:modal-header="{ close }">
        <h5>Create Types</h5>
      </template>
      <p
        v-if="!submiting && !responseSuccess"
      >Are you sure you would like to create the workflow process {{form.onboarding_workflow}} ?</p>
      <div v-else-if="submiting && !responseSuccess">
        <p>Your Form is being submited......</p>
        <b-spinner type="grow" label="Loading..."></b-spinner>
      </div>

      <div v-else>
        <p class="my-2 text-center">
          Your form has been created successfully.
          <br />
        </p>
      </div>
      <div class="float-right">
        <b-button
          size="sm"
          variant="danger"
          class="mr-3"
          v-if="!submiting"
          @click="resetFormModal"
        >Close</b-button>
        <!-- Button with custom close trigger value -->
        <b-button
          size="sm"
          v-if="!responseSuccess"
          :disabled="submiting"
          variant="outline-success"
          @click="postData"
        >Submit</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import { Helper } from "../../helpers";
// import AppHeader from "../../components/header/header";
// import Vue from "vue";
import { mapGetters } from "vuex";
// import AppLoader from "../../components/Loader/Loader";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

import accounting from "accounting";
import moment from "moment";

import { HTTP } from "../../utils/HTTP";
export default {
  name: "ClientProfileWorkflowTypes",
  mixins: [validationMixin],
  components: {},
  data() {
    return {
      isLoading: false,
      filter: null,
      perPage: 5,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "id",
          label: "Id",
          sortable: true
        },
        {
          key: "onboarding_workflow",
          label: "Work flow type",
          sortable: true
        },
        {
          key: "actions",
          label: "",
          sortable: false
        }
      ],
      loading: false,
      pageOptions: [5, 10, 25, 50, 100],
      totalRows: 0,
      showModal: false,
      submiting: false,
      responseSuccess: false,
      moreParams: {},
      form: {
        onboarding_workflow: null
      },
      sortOrder: [
        {
          field: "id",
          sortField: "id",
          direction: "desc"
        }
      ],
     
    };
  },

  computed: {
    rows() {
      return this.totalRows;
    },
    ...mapGetters({
      isGlobalLoader: "isLoading"
    })
  },
  mounted() {},
  validations: {
    form: {
      onboarding_workflow: {
        required,
        minLength: minLength(5)
      }
    }
  },
  methods: {
    async myProvider() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
        clientId: "17"
      };

      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = HTTP(
        "post",
        "v1/client-profile/workflowtype/gettypes",
        formData,
        {
          Authorization: token
        }
      );

      return result
        .then(response => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          return [error];
        });
    },
    itemAction(action, data, index, url) {
      window.location = url;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.showModal = true;
    },
    renderIcon(classes) {
      return `<span class="${classes.join(" ")}"></span>`;
    },
    allcap(value) {
      return value.toUpperCase();
    },

    formatNumber(value) {
      return accounting.formatNumber(value, 2);
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    async postDataApiCall() {
      this.submiting = true;
      this.isLoading = true;
      const URI = "v1/client-profile/workflowtype/create",
        headers = {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        };
      const Result = HTTP(
        "post",
        URI,
        {
          ...this.form,
          clientId: 17
        },
        headers,
        null,
        true
      );
      return Result.then(response => {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        this.$v.$reset();
      }).catch(err => {
        this.isLoading = false;
        this.submiting = false;
      });
    },
    postData() {
      this.postDataApiCall().then(this.reloadTable);
      this.form.onboarding_workflow = null;
    },
    resetFormModal() {
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.showModal = false;
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "my-table");
    }
  }
};
</script>

<style scoped>
.table-col {
  max-height: calc(100vh - 140px);
  overflow-y: scroll;
}
</style>
